/**
 * Maps integration provider names to their S2S service names
 * Used to filter external request logs by integration
 */
export const INTEGRATION_TO_SERVICE_MAP: Record<string, string> = {
  // Analytics & Tracking
  meta_conversion: 'meta',
  klaviyo: 'klaviyo',
  awin_conversion: 'awin',
  triplewhale: 'triplewhale',
  converge: 'converge',
  clickflare: 'clickflare',
  voluum: 'voluum',
  binom: 'binom',
  redtrack: 'redtrack',
  clickmagick: 'clickmagick',
  hyros: 'hyros',

  // Webhooks
  webhooks: 'webhook',
  
  // Note: Other integrations don't have S2S events:
  // - facebook, tiktok, gtm, clarity, snapchat (client-side pixels)
  // - shopify, woocommerce (storefront integrations)
  // - sendcloud (pickup points)
  // - payment methods (no S2S logging)
};

/**
 * Check if an integration has S2S event logs
 */
export function integrationHasS2SLogs(provider: string): boolean {
  return provider in INTEGRATION_TO_SERVICE_MAP;
}

/**
 * Get the service name for filtering S2S logs
 */
export function getServiceNameForIntegration(provider: string): string | null {
  return INTEGRATION_TO_SERVICE_MAP[provider] || null;
}

